<div class="synapi-item-modal-gallery-content" role="dialog" aria-modal="true" tabindex="-1"
     aria-label="Galerie">
  <div class="reverse modal-gallery-header"><span class="h2 modal-gallery-title">{{ item.Title }}</span>
    <button class="button button-outline-white" aria-label="Fermer la galerie" (click)="modal.close()" i18n-aria-label="@@CloseGalery" i18n="@@Close">
      Fermer
    </button>
  </div>
  <div class="modal-gallery-content">
    <swiper class="synapi-item-slider" #swiper [config]="config_swiper">
      <ng-template swiperSlide *ngFor="let image of item.Images; let i = index">
        <div class="slide-container">
          <media-attachment [forceBackground]="true" *ngIf="image" [alt]="image.Name" [url]="image.Url"></media-attachment>
          <div class="image-aside">
            <div class="slide-count">
              {{i+1}} / {{item.Images.length}}
            </div>
            <div class="image-copyright" *ngIf="image.Copyright">
              © {{image.Copyright}}
            </div>
          </div>
        </div>
      </ng-template>
    </swiper>
  </div>
</div>
